import {
    UPDATE_PERCENTAGE_RATE_BEGIN,
    UPDATE_PERCENTAGE_RATE_SUCCESS,
    UPDATE_PERCENTAGE_RATE_FAILURE,
  } from './constants';
  import { BFFAgent } from 'BFFAgent';

  export function updatePercentageRate(rowToEdit) {
    return async(dispatch) => { 
      dispatch({
        type: UPDATE_PERCENTAGE_RATE_BEGIN,
      });
      try{
        const res = await BFFAgent.Datamasters.updatePercentageRate(rowToEdit)
        dispatch({
            type: UPDATE_PERCENTAGE_RATE_SUCCESS,
            data: res,
        });
      }catch(error){
        dispatch({
            type: UPDATE_PERCENTAGE_RATE_FAILURE,
            data: error,
        });
      }
    }
    }
  
  
  export function reducer(state, action) {
    switch (action.type) {
      case UPDATE_PERCENTAGE_RATE_BEGIN:
        return {
          ...state,
          updatePercentagePending: true,
          updatePercentageError: null,
        };
  
      case UPDATE_PERCENTAGE_RATE_SUCCESS:
        return {
          ...state,
          updatePercentagePending: false,
          updatePercentageError: null,
        };
  
      case UPDATE_PERCENTAGE_RATE_FAILURE:
        return {
          ...state,
          updatePercentagePending: false,
          updatePercentageError: action.data.error,
        };
      default:
        return state;
    }
  }
  